export const Style = ({ colors = [] }) => (
  <g id="Estilo1_4_">
    <linearGradient
      id="Multiply_62_"
      gradientUnits="userSpaceOnUse"
      x1="71.25"
      y1="396.3401"
      x2="77.99"
      y2="396.3401"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
      <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
      <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
      <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
      <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
    </linearGradient>
    <path
      id="Multiply_21_"
      style={{
        display: 'inline',
        opacity: '0.6',
        fill: 'url(#Multiply_62_)',
        enableBackground: 'new'
      }}
      d="M71.3,82 c0,0,3,2.8,6.7,1.3c0,0-1,2.7-4.2,1.9C71.3,84.5,71.3,82,71.3,82z"
    />
    <path
      style={{ display: 'inline', fill: colors[0] }}
      d="M70.9,75.1c-0.2,0.6-0.3,1.3-0.3,2c0,3.1,2.5,5.6,5.5,5.6c2.7,0,4.9-1.9,5.4-4.5 L70.9,75.1z"
    />
    <path
      style={{ display: 'inline', fill: '#E8132C' }}
      d="M76,82.7c0.9,0,1.8-0.3,2.6-0.7c-0.5-2.4-2.8-4.3-5.6-4.3c-0.9,0-1.7,0.2-2.4,0.5 C71.2,80.7,73.4,82.7,76,82.7z"
    />
  </g>
)
